import { Injectable } from '@angular/core';
import { PlatformService } from "src/app/system/utility/platform.service";
import { VoiceRecognitionWebService } from './voice-recognition-web.service';
import { VoiceRecognitionService } from './voice-recognition.service';
import { VoiceRecognitionAppService } from './voice-recognition-app.service';
import { ModalController } from '@ionic/angular';
import { VoiceRecognitionComponent } from './voice-recognition.component';
import { AsyncSubject, forkJoin, Observable } from 'rxjs';
import { VoiceRecognitionServerService } from './voice-recognition-server.service';
import { MEAPIService } from '../../services/api/me-api.service';
import { ExternalSettingsService } from '../../services/external-settings/external-settings.service';
import { ExternalSettings } from 'src/app/common/services/external-settings/external-settings.interface';

@Injectable({
    providedIn: 'root'
})
export class VoiceRecognitionUtilityService {

    // Flag to toggle native / server mode for voice recognition
    private isNativeSupported: boolean = false;
    private externalSettings!: ExternalSettings;

    constructor(
        private modalCtrl: ModalController,
        private srvApi: MEAPIService,
        srvES: ExternalSettingsService,
    ) {
        forkJoin([
            srvES.externalSettings$
        ]).subscribe(([externalSettings]) => {
            this.externalSettings = externalSettings;
        });
    }

    public getVoiceRecognitionService(): VoiceRecognitionService {
        if (this.isNativeSupported) {
            if (PlatformService.isBrowser()) {
                return new VoiceRecognitionWebService();
            }
            if (PlatformService.isMobile()) {
                return new VoiceRecognitionAppService();
            }
            throw new Error("Unsupported platform");
        }
        else {
            return new VoiceRecognitionServerService(this.srvApi);
        }
    }

    public isDeviceSupport(): Observable<boolean> {

        // If External Settings is not ready, return false
        if (this.externalSettings) {
            let isSpeechToTextEnabled = this.externalSettings.globalVariables.isSpeechToTextEnabled
            if (isSpeechToTextEnabled) {
                const service = this.getVoiceRecognitionService();
                return service.isDeviceSupport();
            }
        }

        let isDeviceSupport: AsyncSubject<boolean> = new AsyncSubject<boolean>();
        isDeviceSupport.next(false);
        isDeviceSupport.complete();
        return isDeviceSupport.asObservable();
    }

    public openModal(): AsyncSubject<string> {
        let ret = new AsyncSubject<string>();
        this.openDialog(ret);
        return ret;
    }

    private async openDialog(ret: AsyncSubject<string>) {
        const modal = await this.modalCtrl.create({
            component: VoiceRecognitionComponent,
            cssClass: 'voice-dialog',
            backdropDismiss: false,
            keyboardClose: false,
        });
        modal.present();

        const { data, role } = await modal.onWillDismiss();
        if (role === 'message') {
            ret.next(data);
        }
        else {
            ret.next('');
        }
        ret.complete();
    }

}